import fosasApi from "../api/fosasApi"

const getMenu = async() => {   

    const apartados = await fosasApi.get('/apartados.json')            
    return apartados.data || false;
}

export default getMenu;